import * as types from './types'
import { uploadService } from '@/_services'

const actions = {
  setListUploadedFiles({ commit, getters }, { limit, cursor }) {
    commit(types.SET_IS_FETCHING_LIST, { flag: true })
    let listUploadedFilesCursor = getters.getNextCursor
    if (cursor != null) {
      listUploadedFilesCursor = cursor
    }
    uploadService.listUploadedFiles({ limit, cursor: listUploadedFilesCursor })
    .then(({ nextCursor, uploads }) => {
      commit(types.SET_LIST_UPLOADED_FILES, { uploads })
      commit(types.SET_LIST_NEXT_CURSOR, { nextCursor })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_IS_FETCHING_LIST, { flag: false })
    })
  },
  infiniteListUploadedFiles ({ commit, getters }, { limit, cursor }) {
    let listUploadedFilesCursor = getters.getNextCursor
    if (cursor != null) {
      listUploadedFilesCursor = cursor
    }
    commit(types.SET_IS_FETCHING_LIST, { flag: true })
    uploadService.listUploadedFiles({ limit, cursor: listUploadedFilesCursor })
    .then(({ nextCursor, uploads }) => {
      commit(types.INFINITE_SET_LIST_UPLOADED_FILES, { uploads })
      commit(types.SET_LIST_NEXT_CURSOR, { nextCursor })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_IS_FETCHING_LIST, { flag: false })
    })
  },
  refreshListUploadedFiles ({ commit, getters }, { limit }) {
    commit(types.SET_IS_FETCHING_LIST, { flag: true })
    const fileLengthLimit = getters.listUploadedFiles != null ? getters.listUploadedFiles.length : limit
    uploadService.listUploadedFiles({ limit: fileLengthLimit })
    .then(({ nextCursor, uploads }) => {
      commit(types.SET_LIST_UPLOADED_FILES, { uploads })
      commit(types.SET_LIST_NEXT_CURSOR, { nextCursor })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_IS_FETCHING_LIST, { flag: false })
    })
  },
  setUploadStatus({ commit }, { uploadID }) {
    commit(types.SET_IS_FETCHING_STATUS, { flag: true })
    uploadService.getUploadStatus({ uploadID })
    .then((response) => {
      commit(types.SET_UPLOAD_FILE_STATUS, { uploadFile: { ...response, uploadID } })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_IS_FETCHING_STATUS, { flag: false })
    })
  }
}
export default actions
